import React from 'react';
import { Box, Typography, Card, CardContent, List, ListItem, ListItemText } from '@mui/material';

const DepartamentulCimitire: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Departamentul pentru Cimitire
      </Typography>
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Responsabil: Pr. Daniel Manghiucchi
          </Typography>
          <Typography variant="body1">
            Departamentul pentru Cimitire se ocupă de administrarea și 
            întreținerea cimitirelor din cadrul eparhiei.
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default DepartamentulCimitire;
